import { getEntitySlug, slugifySegment } from '@utilities/catalog/slug';

export type CatalogCategory = {
  categoryCodeLevel1?: string | number;
  categoryNameLevel1?: string;
  slug?: string | null;
  iconLink?: string | null;
};

export const getCategorySlug = (category?: CatalogCategory | null) =>
  getEntitySlug({
    slug: category?.slug,
    name: category?.categoryNameLevel1,
    code: category?.categoryCodeLevel1,
  });

export const matchCategoryByListName = (
  categories: CatalogCategory[] = [],
  productListName?: string,
): CatalogCategory | undefined => {
  if (!productListName) return undefined;

  const needle = decodeURIComponent(productListName);
  const needleSlug = slugifySegment(needle);

  return categories.find((category) => {
    const slug = getCategorySlug(category);
    const code = String(category.categoryCodeLevel1 ?? '');
    return (
      slug === needleSlug ||
      slug === needle ||
      code === needle ||
      category.categoryNameLevel1 === needle
    );
  });
};

export type CatalogCategoryLevel2 = {
  categoryCodeLevel2?: string | number;
  categoryNameLevel2?: string;
  slug?: string | null;
  iconLink?: string | null;
};

export const getCategoryLevel2Slug = (category?: CatalogCategoryLevel2 | null) =>
  getEntitySlug({
    slug: category?.slug,
    name: category?.categoryNameLevel2,
    code: category?.categoryCodeLevel2,
  });

export const matchCategoryLevel2ByListName = (
  categories: CatalogCategoryLevel2[] = [],
  productListName?: string,
): CatalogCategoryLevel2 | undefined => {
  if (!productListName) return undefined;

  const needle = decodeURIComponent(productListName);
  const needleSlug = slugifySegment(needle);

  return categories.find((category) => {
    const slug = getCategoryLevel2Slug(category);
    const code = String(category.categoryCodeLevel2 ?? '');
    return (
      slug === needleSlug ||
      slug === needle ||
      code === needle ||
      category.categoryNameLevel2 === needle
    );
  });
};

export type CatalogCategoryLevel3 = {
  categoryCodeLevel3?: string | number;
  categoryNameLevel3?: string;
  slug?: string | null;
  iconLink?: string | null;
};

export const getCategoryLevel3Slug = (category?: CatalogCategoryLevel3 | null) =>
  getEntitySlug({
    slug: category?.slug,
    name: category?.categoryNameLevel3,
    code: category?.categoryCodeLevel3,
  });

export const matchCategoryLevel3ByListName = (
  categories: CatalogCategoryLevel3[] = [],
  listName?: string,
): CatalogCategoryLevel3 | undefined => {
  if (!listName) return undefined;

  const needle = decodeURIComponent(listName);
  const needleSlug = slugifySegment(needle);

  return categories.find((category) => {
    const slug = getCategoryLevel3Slug(category);
    const code = String(category.categoryCodeLevel3 ?? '');
    return (
      slug === needleSlug ||
      slug === needle ||
      code === needle ||
      category.categoryNameLevel3 === needle
    );
  });
};
